import Component_ImageTextures_59061da98d0b2195c1b0af21ae0954a1 from "../../../../content/examples/textures/image-textures/ImageTextures";
import Devtool_ImageTextures_59061da98d0b2195c1b0af21ae0954a1 from "!!@devtool/loader!../../../../content/examples/textures/image-textures/ImageTextures";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_ImageTextures_59061da98d0b2195c1b0af21ae0954a1,
  Devtool_ImageTextures_59061da98d0b2195c1b0af21ae0954a1,
  DevTool,
  React
};